import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { Box, Divider, Type, Alert } from 'react-spark';

import Rlab from '../../components/rlab/Rlab';
import { parseQueryString } from '../../components/routing/helpers';
import services from '../../../services';
import { offersSchema } from '../../components/offers-page-schemas';
import offersV2 from '../../components/offers/offers-v2';
import ABTestPage from './Page';

const { OffersV2Customize, OffersV2Disclaimer, OffersV2Header, OffersV2Help, OffersV2List, OffersV2ExpectationsCard } = offersV2;
const api = services.CoreAPIInstance;

const sharedComponents = {
    header: (firstName, maxOffer, requestedAmountAvailable, customizedOffer) => <Box className="sprk-o-CenteredColumn sprk-u-pvl sprk-u-ptm@m sprk-u-pbm@m">
        <OffersV2Header firstName={firstName} maxOffer={maxOffer} requestedAmountAvailable={requestedAmountAvailable} customizedOffer={customizedOffer}/>
    </Box>,
    specialText: (getsQLDiscount, isTeamMember, getsCyberMondayDiscount, referral, counterOffer, counterOfferReportChanged, loanCreatedDate) => ((getsQLDiscount || isTeamMember || getsCyberMondayDiscount) && (
        <Fragment>
            <Type.BodyFour className='antialiased sprk-u-TextAlign--center sprk-u-man sprk-u-pvs'>
                {getsQLDiscount && (
                    <span className="sprk-u-Display--block">
                        Based on your application, we noticed you have{' '}
                        an active mortgage with our sister company.{' '}
                        <br className='sprk-u-Display--none sprk-u-Display--block@m' />
                        As a thank you for being a valued client,{' '}
                        see your discounted rates below.
                    </span>
                )}

                {isTeamMember && (
                    <span id="teamMemberSubHeading" className="sprk-u-Display--block">
                        Welcome Rock FOC Team Member! As
                        a reminder, any loan option you choose will
                        include 50% off the Origination Fee of the
                        loan.
                    </span>
                )}

                {getsCyberMondayDiscount && (
                    <span id="genericSubHeading" className="sprk-u-Display--block">
                        Don&rsquo;t wait. 50% off your origination fee ends when Cyber Monday does.
                    </span>
                )}
            </Type.BodyFour>

            {
                referral && (
                    <Alert type='success'>
                        <Type.DisplaySix>
                            Thank you for coming from {referral}{`${loanCreatedDate ? ', we see that you applied on ' + new Intl.DateTimeFormat('en-US').format(new Date(loanCreatedDate)) : ''}`}
                        </Type.DisplaySix>
                    </Alert>
                )
            }

            {
                counterOffer && (
                    <Alert type='warning'>
                        <Type.DisplaySix>
                            We are unable to offer you the amount you requested. The good news is that you do qualify for the following loan offers:
                        </Type.DisplaySix>
                    </Alert>
                )
            }

            {
                counterOfferReportChanged && (
                    <Alert type='warning'>
                        <Type.DisplaySix>Your Loan Terms Have Changed</Type.DisplaySix>
                        <Type.DisplaySix>The hard credit inquiry showed a change from the initial soft credit inquiry that was used to generate your loan
                            offers. Please review all your new loan offers below.</Type.DisplaySix>
                    </Alert>
                )
            }</Fragment>
    )),
    expectations: <div className='sprk-u-Display--none@m sprk-u-phh sprk-u-pbl sprk-u-pth'>
        <OffersV2ExpectationsCard
            contentTop={(
                <Type.DisplayFive>
                    What to expect with your loan:
                </Type.DisplayFive>
            )}
            className="sprk-u-mha"
            style={{ boxShadow: 'none' }} />
    </div>,
    bottom: <Box className="sprk-u-ptm sprk-u-pbl sprk-u-mha" style={{ maxWidth: '86rem' }}>
        <OffersV2Help />
        <Divider className="sprk-u-man" />
        <OffersV2Disclaimer />
    </Box>
};
export class OffersPageComponent extends Component {
    static defaultProps = {
        offers: { default: true },
        getsQLDiscount: false,
        isTeamMember: false,
        cardId: '',
        clientStateMinAmount: 0,
        customizedOffer: 0,
        maxOffer: 0,
        minOffer: 0,
        referral: null,
        loanCreatedDate: null,
        counterOffer: false,
        counterOfferReportChanged: false,
        requestedAmountAvailable: false,
    };

    static propTypes = {
        cardId: PropTypes.string.isRequired,
        clientStateMinAmount: PropTypes.number,
        customizedOffer: PropTypes.number.isRequired,
        getsQLDiscount: PropTypes.bool.isRequired,
        isTeamMember: PropTypes.bool.isRequired,
        fetchOffers: PropTypes.func.isRequired,
        fetching: PropTypes.bool.isRequired,
        offers: offersSchema,
        maxOffer: PropTypes.number.isRequired,
        minOffer: PropTypes.number,
        referral: PropTypes.string,
        loanCreatedDate: PropTypes.string,
        counterOffer: PropTypes.bool,
        counterOfferReportChanged: PropTypes.bool,
        requestedAmountAvailable: PropTypes.bool,
    };

    componentWillMount() {
        const queryParams = parseQueryString((this.props.location || window.location).search, window.localStorage);
        const { id, iat, token } = queryParams;
        const fetchParams = id && iat ? { id, iat } : token ? { token } : {};
        this.props.fetchOffers(fetchParams);
        self.scrollHandler = () => {
            const elem = document.getElementsByClassName('top-anchor')[0];
            if (!elem) return;
            if (window.scrollY > 500) {
                elem.style.display = 'block';
            } else {
                elem.style.display = 'none';
            }
        }
        document.addEventListener('scroll', self.scrollHandler);
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', self.scrollHandler);
    }

    render() {
        const {
            cardId,
            customizedOffer,
            clientStateMinAmount,
            getsQLDiscount,
            isTeamMember,
            getsCyberMondayDiscount,
            maxOffer,
            minOffer,
            user,
            referral,
            offers,
            loanCreatedDate,
            counterOffer,
            counterOfferReportChanged,
            requestedAmountAvailable
        } = this.props;

        // no restriction card c display options.
        const maxOptionsDisplayed = cardId === 'C1' ? Infinity : 6;
        const { firstName = '' } = user || {};
        let customizedOfferLow = this.props.customizedOffer;
        if (offers && offers.sortedOffers && offers.sortedOffers.length) {
            customizedOfferLow = offers.sortedOffers[0].amount;
        }
        return (
            <ABTestPage
                id="offersPage"
                loading={this.props.fetching}
                heading=""
                // Applied so the default container class is not used
                className=""
                padding="flush"
                api={api}
                rlabPage="offersPage">
                <Rlab
                    campaignCode="2024-07-ABTest-offersListOrdering"
                    components={
                        {
                            control: <Fragment>
                                {sharedComponents.header(firstName, maxOffer)}
                                <div className='sprk-u-pvl sprk-u-BackgroundColor--gray'>
                                    <Box className="sprk-o-CenteredColumn">
                                        {/* Customization */}
                                        <OffersV2Customize
                                            clientStateMinAmount={clientStateMinAmount}
                                            customizedOffer={customizedOfferLow}
                                            maxOffer={maxOffer}
                                            minOffer={minOffer}
                                            requestedAmountAvailable={requestedAmountAvailable}
                                        />
                                        {sharedComponents.specialText(getsQLDiscount, isTeamMember, getsCyberMondayDiscount, referral, counterOffer, counterOfferReportChanged, loanCreatedDate)}
                                        <OffersV2List />
                                        {sharedComponents.expectations}
                                    </Box >
                                </div >
                                {sharedComponents.bottom}
                            </Fragment >,
                            experiment: <Fragment>
                                {sharedComponents.header(firstName, maxOffer, requestedAmountAvailable, customizedOffer)}
                                <div className='sprk-u-pvm sprk-u-BackgroundColor--gray'
                                    // Used for our web-ui authenticated offers page /app#/loan-options/
                                    style={{ width: '100vw', marginLeft: 'calc(50% - 50vw)'}}>
                                    <Box className="sprk-o-CenteredColumn">
                                        {sharedComponents.specialText(getsQLDiscount, isTeamMember, getsCyberMondayDiscount, referral, counterOffer, counterOfferReportChanged, loanCreatedDate)}
                                        <Type.DisplayFive className='sprk-u-mbn'>
                                            { requestedAmountAvailable ? 'Your Requested Offer' : 'Your Top Offers'}
                                        </Type.DisplayFive>
                                        <OffersV2List descending maxOffers={maxOptionsDisplayed} />
                                    </Box>
                                </div>
                                {/* Customization */}
                                <Box className="sprk-o-CenteredColumn">
                                    <OffersV2Customize
                                        clientStateMinAmount={clientStateMinAmount}
                                        customizedOffer={customizedOffer}
                                        maxOffer={maxOffer}
                                        minOffer={minOffer}
                                        selectionHighToLow={true}
                                        requestedAmountAvailable={requestedAmountAvailable}
                                    />
                                </Box>
                                <div className='sprk-u-BackgroundColor--gray' style={{ width: '100vw', marginLeft: 'calc(50% - 50vw)'}}>
                                    {sharedComponents.expectations}
                                    <Box className="sprk-o-CenteredColumn">
                                        <OffersV2Help />
                                    </Box>
                                </div>
                                <div className='sprk-u-BackgroundColor--white'>
                                    <Box className="sprk-o-CenteredColumn">
                                        <Divider className="sprk-u-man" />
                                        <OffersV2Disclaimer />
                                    </Box>
                                </div>
                                <div
                                    className="top-anchor"
                                    onClick={() => window.scrollTo({
                                        top: document.getElementById('customize-offers').offsetTop - document.getElementsByClassName('sprk-c-Masthead')[0].offsetHeight,
                                        behavior: 'smooth'
                                    })}>
                                </div>
                            </Fragment>,
                        }
                    }
                />
            </ABTestPage >
        );
    }
}

export default OffersPageComponent;

